//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignInForm from '@/components/forms/SignInForm.vue';
export default {
  components: {
    SignInForm
  },
  mounted() {
    if (this.$auth.$state.loggedIn) {
      this.$router.push('/dashboard');
    }
  }
};
